/*
  Accessible show-more/fewer toggle for the blog sidebar's tag chip list
  (snippets/blog-sidebar.liquid). Every tag is always present in the
  rendered HTML - this only toggles the native "hidden" attribute on the
  overflow items, so nothing is removed from the page for search engines,
  it's just visually/AT-collapsed until expanded, same as any standard
  accordion/show-more pattern.

  - Event delegation: one listener handles every toggle button on the
    page, and re-runs safely after a Shopify theme-editor section reload
    (guarded by data-blog-tags-initialised so it's never bound twice).
  - aria-expanded on the button and the native hidden attribute on the
    overflow <li> items are the single source of truth; no CSS classes
    duplicate that state.
*/
(function () {
  "use strict";

  function toggleTags(button) {
    var panel = document.getElementById(button.getAttribute("aria-controls"));
    if (!panel) return;

    var isExpanded = button.getAttribute("aria-expanded") === "true";
    var extraItems = panel.querySelectorAll(".tt-tag-chips__item--extra");

    extraItems.forEach(function (item) {
      if (isExpanded) {
        item.setAttribute("hidden", "");
      } else {
        item.removeAttribute("hidden");
      }
    });

    button.setAttribute("aria-expanded", String(!isExpanded));
    button.textContent = isExpanded
      ? button.getAttribute("data-more-label")
      : button.getAttribute("data-fewer-label");
  }

  function init(root) {
    var container = root || document;
    if (container.dataset && container.dataset.blogTagsInitialised === "true") return;
    if (container.dataset) container.dataset.blogTagsInitialised = "true";

    container.addEventListener("click", function (event) {
      var button = event.target.closest("[data-tag-toggle]");
      if (!button || !container.contains(button)) return;
      toggleTags(button);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
